import WorkspaceMembersSettings from '@/pages/settings/workspace-members'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/settings/members',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <WorkspaceMembersSettings/>
  )
}
